// @ vendor
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/actionTypes');
const { FIRST_STEP } = require('constants/index');
// @ reducers
const cardTransferMoneyStep1 = require('./cardTransferMoney/cardTransferMoneyStep1');

const setInitialState = () => {
    return Immutable.fromJS({
        steps: [
            cardTransferMoneyStep1(undefined, {type: null}),
            {hasSignaturePattern: true}
        ],
        visibleStep: 1,
        isFetching: false,
        inProgress: false,
        submitSuccessful: false,
        submitError: false,
        willLeave: false,
        willCancel: false,
        error: '',
        errorReceived: '',
        canReceiveDeposit: false,
        cardDetails:{},
        getCardDetailsError: ''
    });
}

const updateStep = (index, steps, action) => {
    return steps.update(index, step => {
        switch (index) {
            case FIRST_STEP:
                return cardTransferMoneyStep1(step, action);
        }
    })
}

const cardTransferMoneyReducer = (state = setInitialState(), action) => {
    let partialSteps;
    switch (action.type) {
        case actionTypes.CARD_TRANSFER_DETAILS_REQUEST:
            return state.merge({
                isFetching: true
            })
        case actionTypes.CARD_TRANSFER_MONEY_VALIDATE_STEP:
            let visibleStep;
            switch (action.payload.step) {
                case 1:
                    partialSteps = updateStep(FIRST_STEP, state.get('steps'), action);
                    visibleStep = partialSteps.get(FIRST_STEP).get('valid') ? 2 : 1;

                    return state.mergeDeep({
                        steps: partialSteps,
                        visibleStep
                    })
            }
            return state;
        case actionTypes.CARD_TRANSFER_MONEY_SET_VISIBLE_STEP:
            return state.merge({
                visibleStep: action.payload.step
            })
        case actionTypes.CARD_TRANSFER_MONEY_SET_AMOUNT:
        case actionTypes.CARD_TRANSFER_MONEY_AVAILABLE_BALANCE:
            return state.merge({
                steps: updateStep(FIRST_STEP, state.get('steps'), action),
                inProgress: true
            })
        case actionTypes.CARD_TRANSFER_MONEY_WILL_CANCEL:
            return state.merge({
                willCancel: action.payload.willCancel
            })
        case actionTypes.CARD_TRANSFER_MONEY_CLEAR:
            return setInitialState();
        case actionTypes.CARD_TRANSFER_MONEY_SUCCESS:
            return state.merge({
                isFetching: false,
                submitSuccessful: true,
                errorReceived: '',
                inProgress: false
            })
        case actionTypes.CARD_TRANSFER_MONEY_FAILURE:
            return state.merge({
                isFetching: false,
                submitError: true,
                error: action.error.body.error,
                errorReceived: action.error.error
            })
        case actionTypes.CARD_TRANSFER_DETAILS_SUCCESS:
            return state.mergeDeep({
                isFetching: false,
                cardDetails: action.payload.cardDetails
            })
        case actionTypes.CARD_TRANSFER_DETAILS_ERROR:
            return state.merge({
                isFetching: false,
                getCardDetailsError: action.payload.error
            })
        default:
            return state
    }
}

module.exports = cardTransferMoneyReducer;
